import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue } from '../../../entities/form-value.entity';
import { ShFormToggleSwitchComplexBaseComponent } from '../base-complex/form-toggle-switch-complex-base.component';

@Component({
    selector: 'sh-form-toggle-switch-base',
    templateUrl: '../base-complex/form-toggle-switch-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormToggleSwitchBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule]
})
export class ShFormToggleSwitchBaseComponent extends ShFormToggleSwitchComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(fv: FormValue<boolean | null>): void {
        this.propagateSimpleChange(FormValue.unwrap(fv));
    }

    writeValue(obj: any): void {
        super.writeValue(FormValue.wrap(obj));
    }
}
